import { createFileRoute } from '@tanstack/react-router';

import Page from '@/screens/settings/personal/imports/chatgpt/page';

export const Route = createFileRoute('/_app/settings/personal/imports/chatgpt/')({
  component: Page,
});
